import {useEffect, useRef} from 'react';

export type UseDocumentKeyDownOptions = {
	disabled?: boolean;
};

export const USE_DOCUMENT_KEY_DOWN_DEFAULTS = {
	disabled: false,
};

export const useDocumentKeyDown = (
	cb: (event: KeyboardEvent) => boolean | void,
	{disabled}: UseDocumentKeyDownOptions = USE_DOCUMENT_KEY_DOWN_DEFAULTS,
) => {
	const cbRef = useRef(cb);
	useEffect(() => {
		cbRef.current = cb;
	});

	useEffect(() => {
		if (disabled) return;

		const onKeyDown = (event: KeyboardEvent) => {
			if (cbRef.current(event) === false) {
				event.preventDefault();
				event.stopPropagation();
			}
		};

		document.addEventListener('keydown', onKeyDown, {capture: true});

		return () => {
			document.removeEventListener('keydown', onKeyDown, {capture: true});
		};
	}, [disabled]);
};

export default useDocumentKeyDown;
